<app-modal-footer
  (primaryButtonClicked)="cookieAccepted()"
        [hideSecondaryButton]="true">
</app-modal-footer>
